<div id="audioPlayWrap" (touchmove)="touchmove($event)" (touchend)="touchend()">
  <audio src="{{assetsRoute}}/audio/afterReportAudio.m4a" (canplaythrough)="canplaythrough()" (warting)="warting()" (timeupdate)="timeupdate()" (play)="play()" (pause)="pause()" (ended)="ended()" (loadeddata)="loadeddata()"   crossorigin="*">
  </audio>
  <!--操作界面-->
  <div class="audioPlay-controller" >
    <div class="audioPlay-bar">
      <div class="audioPlay-btn-play fa fa-play-circle"  *ngIf="!playStatus"  (click)="playAudio()"></div>
      <div class="audioPlay-btn-play fa fa-pause-circle" *ngIf="playStatus" (click)="playAudio()"></div>
    </div>
    <div class="audioPlay-progress">
      <div class="audioPlay-current"></div>
      <div class="audioPlay-play-wrap">
        <div class="audioPlay-play" [ngStyle]="{'width':  audioProcess + '%'}"><div class="audioPlay-playingBar" (touchstart)="touchstart($event)" (mousedown)="touchstart($event)">{{audioProcessTimes}}</div></div>
      </div>
    </div>
  </div>
</div>






// WEBPACK FOOTER //
// ./src/app/app-audio-play-base/app-audio-play-base.component.html